<span 
    class="material-symbols-rounded"
    matTooltipPosition="above"  
    matTooltipClass="custom-tooltip"
    [matTooltip]="tooltipInfo"
>
    error
</span>